import { useCabinetText } from "../../content/CabinetContentContext";
// components/userCabinet/LibraryOffersBanner.jsx
import { useEffect, useState } from "react";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../../firebase";
import css from "./libraryOffersBanner.module.css";
export default function LibraryOffersBanner() {
  const t = useCabinetText("libraryOffers");
  const [offers, setOffers] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const fetchOffers = async () => {
      try {
        const ref = collection(db, "libraryOffersBanners");
        const snap = await getDocs(ref);

        const list = snap.docs
          .map((d) => ({ id: d.id, ...d.data() }))
          .filter((b) => b.active === true)
          .sort((a, b) => (a.order ?? 0) - (b.order ?? 0));

        console.log("OFFERS:", list);
        setOffers(list);
      } catch (err) {
        console.error("Помилка завантаження акційних банерів:", err);
      }
    };

    fetchOffers();
  }, []);

  if (!offers.length) return null;

  const current = offers[currentIndex];

  const handlePrev = () => {
    setCurrentIndex((prev) => (prev === 0 ? offers.length - 1 : prev - 1));
  };

  const handleNext = () => {
    setCurrentIndex((prev) => (prev === offers.length - 1 ? 0 : prev + 1));
  };

  const handleClick = () => {
    if (current.linkUrl) {
      window.open(current.linkUrl, "_blank", "noopener,noreferrer");
    }
  };

  return (
    <>
      <div className={css.whiteBlock}></div>
      <div className="newBooksWrapBlock">
        {/* Лівий зелений блок – та ж сітка, що в OpikunRada */}
        <div className="GreenBlockMal">
          <div className="smallWrapForO">
            <h1 className="HelpCreateBooks">{t("text001")}</h1>

            <p className="giveDiscount">{t("text002")}</p>

            {current.title && (
              <h1 className="nameBooksNewBooksMal">{current.title}</h1>
            )}

            {current.description && (
              <p className="descriptionOpikunBook">{current.description}</p>
            )}
          </div>

          {/* Тут замість "Що таке опікунська рада" – навігація по слайдах */}
          <div className="whoyIsOpRada">
            <button
              type="button"
              onClick={handlePrev}
              className={css.whiteButton}
            >
              ‹
            </button>
            <span style={{ margin: "0 8px" }}>
              {currentIndex + 1} / {offers.length}
            </span>
            <button
              type="button"
              onClick={handleNext}
              className={css.whiteButton}
            >
              ›
            </button>
          </div>
        </div>

        {/* Правий блок з картинкою + кнопка – як BorderWrapBlurOp */}
        <div className="BorderWrapBlurOp">
          <div className="imgPictureBoxOpicun">
            {current.imageUrl && (
              <img
                src={current.imageUrl}
                className="opicunPicture"
                alt={current.title || "Акційна пропозиція"}
              />
            )}
          </div>

          <div className="opRadaButton" onClick={handleClick}>
            {current.buttonText || t("label004")}
          </div>
        </div>
      </div>
    </>
  );
}
